module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar maxOptionsIndex;\n// prepare config\nvar renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};\nvar groupConfig = renderConfig.groupEntries || {};\ngroupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);\nvar childConfig = renderConfig.optionEntries || {};\nchildConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);\nvar isGrouped = !!groupConfig.name;\n// prepare user-lang\nconst langCode = storage.langCode\n// prepare relation config\nvar isRelationField;\nvar relationConfig;\nif(!!model.config && !!model.config.relationConfig){\nisRelationField = true;\nrelationConfig = model.config.relationConfig;\n}\n// prepare source-data-flag\nvar dataAttributeKey;\nif(!!model.atom && !!model.atom.dataType){\ndataAttributeKey = model.atom.dataType + '-data';\n} else {\ndataAttributeKey = 'data';\n}\n// prepare options\nvar options;\nif(Array.isArray(model[dataAttributeKey])){\noptions = model[dataAttributeKey];\n}\nelse if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){\noptions = model[dataAttributeKey].options;\n}\n// prepare default entry\nif(renderConfig.defaultOptionEntry){\nvar entry = {};\nif(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){\nentry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\nelse {\nentry[childConfig.name] = renderConfig.defaultOptionEntry.name;\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\noptions.unshift(entry);\n}\nvar optionListHtml = '';\nvar valueListHtml = '';\nif(!!options){\nvar optionConfig = childConfig;\nutils.forEach(options, function(option, optionIndex){\nmaxOptionsIndex = optionIndex;\n// define option name\nvar optionName;\nif(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){\noptionName = option.lang[langCode][optionConfig.name];\n} else if (!!option[optionConfig.name]) {\noptionName = option[optionConfig.name];\n} else {\noptionName = '-NO-NAME-FOUND-';\n}\n// define if option is selected\nvar optionSelected = false;\nvar relationDataIndex;\nif(isRelationField){\nif(Array.isArray(model.dataJSON)){\nfor(relationDataIndex in model.dataJSON){\nif(model.dataJSON[relationDataIndex].attributes[relationConfig.assignedPrimaryKey] == option[optionConfig.value]){\noptionSelected = true;\nbreak;\n}\n}\n}\n}\nelse if(Array.isArray(model.dataJSON)){\noptionSelected = utils.indexOf(model.dataJSON, option.value) >= 0;\n} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){\noptionSelected = option[optionConfig.value] == model.dataTEXT;\n} else {\noptionSelected = !!option.defaultSelected;\n}\noptionListHtml += include('./autoCompleteBubbleOption', { model: { value: option[optionConfig.value], name: optionName, optionSelected: optionSelected, relationDataIndex: relationDataIndex }});\nif(optionSelected){\nvalueListHtml += include('./autoCompleteBubbleOption', { model: { value: option[optionConfig.value], name: optionName, relationDataIndex: relationDataIndex, valueItem: true }});\n}\n});\n}\n%>\n<div class=\"<%- (disabled ? 'disabled' : '') %>\">\n<%\nif(!disabled){\n%>\n<button class=\"open\"><i class=\"fi fi-plus-circle\"></i></button>\n<%\n}\n%>\n<div class=\"valueList\">\n<ul>\n<%- valueListHtml %>\n</ul>\n</div>\n<%\nif(!disabled){\n%>\n<div class=\"optionList\">\n<input type=\"text\" value=\"\" />\n<ul>\n<%- optionListHtml %>\n</ul>\n</div>\n<%\n}\n%>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\tagPicker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var maxOptionsIndex;
// prepare config
var renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};
var groupConfig = renderConfig.groupEntries || {};
groupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);
var childConfig = renderConfig.optionEntries || {};
childConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);
var isGrouped = !!groupConfig.name;
// prepare user-lang
const langCode = storage.langCode
// prepare relation config
var isRelationField;
var relationConfig;
if(!!model.config && !!model.config.relationConfig){
isRelationField = true;
relationConfig = model.config.relationConfig;
}
// prepare source-data-flag
var dataAttributeKey;
if(!!model.atom && !!model.atom.dataType){
dataAttributeKey = model.atom.dataType + '-data';
} else {
dataAttributeKey = 'data';
}
// prepare options
var options;
if(Array.isArray(model[dataAttributeKey])){
options = model[dataAttributeKey];
}
else if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){
options = model[dataAttributeKey].options;
}
// prepare default entry
if(renderConfig.defaultOptionEntry){
var entry = {};
if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
else {
entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
options.unshift(entry);
}
var optionListHtml = '';
var valueListHtml = '';
if(!!options){
var optionConfig = childConfig;
utils.forEach(options, function(option, optionIndex){
maxOptionsIndex = optionIndex;
// define option name
var optionName;
if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){
optionName = option.lang[langCode][optionConfig.name];
} else if (!!option[optionConfig.name]) {
optionName = option[optionConfig.name];
} else {
optionName = '-NO-NAME-FOUND-';
}
// define if option is selected
var optionSelected = false;
var relationDataIndex;
if(isRelationField){
if(Array.isArray(model.dataJSON)){
for(relationDataIndex in model.dataJSON){
if(model.dataJSON[relationDataIndex].attributes[relationConfig.assignedPrimaryKey] == option[optionConfig.value]){
optionSelected = true;
break;
}
}
}
}
else if(Array.isArray(model.dataJSON)){
optionSelected = utils.indexOf(model.dataJSON, option.value) >= 0;
} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){
optionSelected = option[optionConfig.value] == model.dataTEXT;
} else {
optionSelected = !!option.defaultSelected;
}
optionListHtml += include('./autoCompleteBubbleOption', { model: { value: option[optionConfig.value], name: optionName, optionSelected: optionSelected, relationDataIndex: relationDataIndex }});
if(optionSelected){
valueListHtml += include('./autoCompleteBubbleOption', { model: { value: option[optionConfig.value], name: optionName, relationDataIndex: relationDataIndex, valueItem: true }});
}
});
}

    ; __line = 92
    ; __append("\n<div class=\"")
    ; __line = 93
    ; __append( (disabled ? 'disabled' : '') )
    ; __append("\">\n")
    ; __line = 94
    ; 
if(!disabled){

    ; __line = 96
    ; __append("\n<button class=\"open\"><i class=\"fi fi-plus-circle\"></i></button>\n")
    ; __line = 98
    ; 
}

    ; __line = 100
    ; __append("\n<div class=\"valueList\">\n<ul>\n")
    ; __line = 103
    ; __append( valueListHtml )
    ; __append("\n</ul>\n</div>\n")
    ; __line = 106
    ; 
if(!disabled){

    ; __line = 108
    ; __append("\n<div class=\"optionList\">\n<input type=\"text\" value=\"\" />\n<ul>\n")
    ; __line = 112
    ; __append( optionListHtml )
    ; __append("\n</ul>\n</div>\n")
    ; __line = 115
    ; 
}

    ; __line = 117
    ; __append("\n</div>")
    ; __line = 118
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\tagPicker.ejs

}